import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import './CTASection.css';

const DataFlowBg = () => (
  <svg className="final-cta-bg-svg" viewBox="0 0 600 400" preserveAspectRatio="xMaxYMid slice">
    <circle cx="500" cy="200" r="120" fill="none" stroke="#037eb7" strokeWidth="1" strokeDasharray="4 6" opacity="0.5" />
    <circle cx="500" cy="200" r="180" fill="none" stroke="#60a5fa" strokeWidth="0.5" opacity="0.3" />
    <circle cx="500" cy="200" r="240" fill="none" stroke="#cbd5e1" strokeWidth="0.5" opacity="0.1" />
    
    <path d="M 0 200 C 200 200, 300 50, 500 200" fill="none" stroke="#60a5fa" strokeWidth="1" opacity="0.6" />
    <path d="M 100 350 C 300 350, 400 300, 500 200" fill="none" stroke="#037eb7" strokeWidth="1.5" opacity="0.8" />
    
    <circle cx="500" cy="200" r="6" fill="#037eb7" />
    <circle cx="200" cy="140" r="3" fill="#60a5fa" />
    <circle cx="350" cy="320" r="4" fill="#cbd5e1" />
  </svg>
);

const CTASection = () => {
  return (
    <section className="final-cta-section">
      <DataFlowBg />
      
      <div className="final-cta-container">
        <motion.span 
          className="final-cta-eyebrow"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.5 }}
        >
          LET'S TALK DATA
        </motion.span>

        <motion.h2 
          className="final-cta-heading"
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Ready to Turn Your Data Into <span className="highlight">Better Decisions</span>?
        </motion.h2>

        <motion.p 
          className="final-cta-desc"
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Tell us what you are trying to solve and our team will help identify the right data, analytics or technology approach.
        </motion.p>

        <motion.div 
          className="final-cta-actions"
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <Link to="/contact-us" className="final-cta-btn final-cta-btn-primary">
            Contact Us <FiArrowRight className="final-cta-btn-icon" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;